import { createSafeContext } from '../../helpers/createSafeContext';
export const [AppLayoutProvider, useAppLayoutContext] = createSafeContext('You forgot to wrap your component in <AppLayoutProvider />.');
